/** @jsx h */
import { h } from 'preact'

const HelpIcon = ({ style = {}, width = '18', height = '18', className = '', viewBox = '0 0 18 18' }) => (
  <svg
    id='rcc_c_help-icon'
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`help-icon ${className}`}
    aria-hidden='true'
  >
    <path
      id='Path_3599'
      data-name='Path 3599'
      d='M757.217,404.389a.994.994,0,0,0-.729.3,1,1,0,0,0-.3.738,1.028,1.028,0,0,0,1.03,1.029,1.008,1.008,0,0,0,.732-.3.982.982,0,0,0,.307-.728,1.03,1.03,0,0,0-1.039-1.039Z'
      transform='translate(-747.497 -390)'
    />
    <path
      id='Path_3600'
      data-name='Path 3600'
      d='M760.293,394.621a3.6,3.6,0,0,0-2.965-1.186,3.732,3.732,0,0,0-2.573.857,2.636,2.636,0,0,0-.967,2.005,1.827,1.827,0,0,0,.366,1.2,1.112,1.112,0,0,0,.864.458.88.88,0,0,0,.665-.291.987.987,0,0,0,.268-.7,1.931,1.931,0,0,0-.3-.858,1.653,1.653,0,0,1-.252-.748.879.879,0,0,1,.39-.67,1.956,1.956,0,0,1,2.531.294,2.521,2.521,0,0,1,.575,1.741,3.77,3.77,0,0,1-.159,1.08,9.681,9.681,0,0,1-.709,1.573,13.257,13.257,0,0,0-.956,2.164,7.209,7.209,0,0,0-.213,1.105h.8a3.281,3.281,0,0,1,.239-.776,11.846,11.846,0,0,1,1.616-2.111,6.848,6.848,0,0,0,1.18-1.734,3.792,3.792,0,0,0,.317-1.468A2.993,2.993,0,0,0,760.293,394.621Z'
      transform='translate(-747.497 -390)'
    />
  </svg>
)

export default HelpIcon
